import "./segmentList.css";
import { data } from "../Segment/data";
import Segment from "./Segment";
import { useRef } from "react";

const SegmentList = () => {
  const level = useRef(0);

  return (
    <div className="segment-list-wrapper">
      {data.map((segment) => {
        return (
          <Segment
            name={segment.name}
            check={segment.check}
            data={segment.data}
            level={level.current}
          ></Segment>
        );
      })}
    </div>
  );
};

export default SegmentList;
